<template>
  <div class="main-content">
    <router-link
      :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
      class="news-item"
      v-for="item in list"
      :key="item.id"
    >
      <div class="news-content">
        <div>
          <div class="img-holder">
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
              class="img"
            />
            <div class="cat-wrapper">
              <div class="cat-meta">{{ item.sub_category.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="title limited-text">
        {{ item.title }}
      </div>
      <div class="date-wrapper">
        <span class="date">{{ handleDate(item.pub_date) }},</span>
        <span class="date" style="padding-left: 0.44em">
          {{ handleTime(item.pub_date) }}</span
        >
      </div>
    </router-link>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "SecondBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  position: relative;
  width: var(--width-content);
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-areas:
    "card-1 card-1 card-2 card-2"
    "card-3 card-4 card-5 card-6"
    "card-7 card-7 card-8 card-8"
    "card-9 card-10 card-11 card-12";
  grid-gap: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 5em;
  margin: 0 auto;

  .news-item {
    // width: 360px;
    height: auto;
    position: relative;
    padding-bottom: 4.375rem;
    margin: 0 1rem;
    &:nth-child(1) {
      grid-area: card-1;
    }
    &:nth-child(2) {
      grid-area: card-2;
    }
    &:nth-child(3) {
      grid-area: card-3;
    }
    &:nth-child(4) {
      grid-area: card-4;
    }
    &:nth-child(5) {
      grid-area: card-5;
    }
    &:nth-child(6) {
      grid-area: card-6;
    }
    &:nth-child(7) {
      grid-area: card-7;
    }
    &:nth-child(8) {
      grid-area: card-8;
    }
    &:nth-child(9) {
      grid-area: card-9;
    }
    &:nth-child(10) {
      grid-area: card-10;
    }
    &:nth-child(11) {
      grid-area: card-11;
    }
    &:nth-child(12) {
      grid-area: card-12;
    }

    .news-content {
      width: 100%;
      padding-bottom: 0.75em;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .img-holder {
      width: 100%;
      border-radius: 4px;
      padding-top: 59.09%; /* 22:13 Aspect Ratio */
      position: relative;
      overflow: hidden;

      .img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 4px;
        transition: all 0.4s ease;
      }

      .cat-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        background-color: var(--background-color);
        height: 1.6em;
        font-family: Open Sans;
        .cat-meta {
          display: flex;
          align-items: center;
          justify-content: center;
          &:first-child {
            font-weight: 600;
            text-transform: uppercase;
            padding: 0 0.375rem;
          }
        }
      }
    }
    .title {
      font-family: Roboto;
      font-size: 1.25em;
      font-weight: 500;
      line-height: 1.5em;
      // padding-top: 0.625rem;
    }
    .date-wrapper {
      display: flex;
      font-weight: 300;
      font-size: 0.875em;
      padding-top: 0.75em;
      opacity: 0.8;
      font-family: Open Sans;
    }
  }
}

@media screen and (min-width: 993px) {
  .main-content {
    .news-item {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(7),
      &:nth-child(8) {
        .title {
          text-align: center;
        }

        .date-wrapper {
          justify-content: center;
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .main-content {
    grid-template-columns: repeat(6, 1fr);
    grid-template-areas:
      "card-1 card-1 card-1 card-2 card-2 card-2"
      "card-3 card-3 card-4 card-4 card-5 card-5"
      "card-6 card-6 card-6 card-7 card-7 card-7"
      "card-8 card-8 card-9 card-9 card-10 card-10"
      "card-11 card-11 card-11 card-12 card-12 card-12";

    .news-item {
      padding-bottom: 1rem;
      margin: 0;
    }

    .title {
      padding-top: 0;
    }
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  .main-content {
    .news-item {
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(11),
      &:nth-child(12) {
        .title {
          text-align: center;
        }

        .date-wrapper {
          justify-content: center;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .main-content {
    grid-template-areas:
      "card-1 card-1 card-1 card-2 card-2 card-2"
      "card-3 card-3 card-3 card-3 card-3 card-3"
      "card-4 card-4 card-4 card-5 card-5 card-5"
      "card-6 card-6 card-6 card-6 card-6 card-6"
      "card-7 card-7 card-7 card-8 card-8 card-8"
      "card-9 card-9 card-9 card-9 card-9 card-9"
      "card-10 card-10 card-10 card-11 card-11 card-11"
      "card-12 card-12 card-12 card-12 card-12 card-12";

    .title {
      padding-top: 0;
    }

    .news-item {
      &:nth-child(3),
      &:nth-child(6),
      &:nth-child(9) {
        .title {
          text-align: center;
        }

        .date-wrapper {
          justify-content: center;
        }
      }
    }
  }
}

@media screen and (max-width: 395px) {
  .main-content {
    width: 95%;
    .news-item {
      .title {
        font-size: 0.925em;
      }
      .news-content {
        .cat-wrapper {
          font-size: 10px;
          height: 1.1rem;
        }
      }
    }
  }
}
</style>
